import React, { Component } from 'react'
import EntryScreen from './EntryScreen.jsx'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { withRouter } from 'react-router'
import { notify } from 'react-notify-toast'
import { isMobile } from 'react-device-detect'
import slugify from 'slugify'
import moment from 'moment'
import cookie from 'react-cookies'
import { trackPromise } from 'react-promise-tracker'

import {
  generatePhotoAwsUrl,
  putPhoto,
  // getPhotos,
  editImage,
  getUserData,
  getUserFeed,
  uploadFileToAmazon,
  compressImages,
  deleteFeed,
  editUserFeedDimensions,
  getTrainingDays,
} from '../../Api/backendApi'
import { getAllUserWatchedVideos } from '../../Api/videoApi'

import * as entryActions from '../../actions/entryActions'
import { scrollFixer } from '../theme/mixins'

class EntryScreenContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openMenu: false,
      isPlayerActive: false,
      userFeed: {},
      userFrontPhoto: [],
      userBackPhoto: [],
      userSidePhoto: [],
      imagePosition: 'center',
      isPhotoReadyForRemove: false,
      entryDate: this.props.match.params.entryDate,
      userBackBackground: null,
      userFrontBackground: null,
      userSideBackground: null,
      isAgreementButtonsOn: false,
      isLoading: false,
      isEditEntry: false,
      isEditImageModalOpen: false,
      currentEditingSide: null,
      isRemoveEntryModalOpen: false,
      showCompareButton: false,
      isEditDimensionsModalOpen: false,
      edit_thigh_circumference: null,
      edit_hip_circumference: null,
      edit_belly_circumference: null,
      tempUserFrontBackground: null,
      tempUserBackBackground: null,
      tempUserSideBackground: null,
      isDemoAccount: cookie.load('userDemoMode'),

      // entryDate: slugify(
      //   `${this.props.location.state.userEntry.time.day} ${this.props.location.state.userEntry.time.monthNumber} ${this.props.location.state.userEntry.time.year}`
      // ),
    }
  }

  onNotCurrentDayAddImageError = () => {
    notify.show(
      'Możesz dodać zdjęcie tylko dla wpisu z obecnego dnia.',
      'error',
      5000
    )
  }

  setLoader = () => {
    this.setState({
      isLoading: !this.state.isLoading,
    })
  }

  checkIfUserAlreadyUploadedPhoto = (option) => {
    let image
    if (this.props.user.entries) {
      image = this.props.user.entries.filter(
        (entry) => entry.dateSlug === this.state.entryDate
      )

      image.map((img) => {
        if (img.hasOwnProperty('userFrontPhoto')) {
          this.setState({
            userFrontPhoto: img.userFrontPhoto,
          })
        } else if (img.hasOwnProperty('userSidePhoto')) {
          this.setState({
            userSidePhoto: img.userSidePhoto,
          })
        } else if (img.hasOwnProperty('userBackPhoto')) {
          this.setState({
            userBackPhoto: img.userBackPhoto,
          })
        }
      })
    }
  }

  getCurrentFeed = async () => {
    const userFeed = await getUserFeed()
    this.setState({
      allUserFeeds: userFeed,
    })
    if (userFeed) {
      const filteredFeeds = await userFeed.filter(
        (feed) => feed.creation_datetime == this.state.entryDate
      )

      this.setState({
        currentFeed: filteredFeeds[0],
      })
    }
  }

  componentDidMount = async () => {
    let userData = await trackPromise(getUserData())

    this.setState({
      user: userData,
    })

    await this.getCurrentFeed()
    await this.obtainPhotos()
    const scrollContainer = document.querySelector('.indiana-scroll-container')
    const scrolledWidth = `${
      (window.innerWidth / 9.5) * 2 - window.innerWidth / scrollFixer()
    }`
    if (!isMobile) {
      scrollContainer.scrollTo(`${scrolledWidth}`, 0)
    } else if (window.innerWidth < 1100) {
      scrollContainer.scrollTo(window.innerWidth, 0)
    } else {
      scrollContainer.scrollTo(window.innerWidth * 0.86, 0)
    }
    this.checkIfUserAlreadyUploadedPhoto()
    this.enableCompareButton()
  }

  obtainPhotos = () => {
    if (this.state.currentFeed.photos) {
      this.state.currentFeed.photos.forEach((photo) => {
        switch (photo.type) {
          case 'F':
            this.setState({
              userFrontBackground: photo.url,
            })
            break
          case 'S':
            this.setState({
              userSideBackground: photo.url,
            })
            break
          case 'B':
            this.setState({
              userBackBackground: photo.url,
            })
            break
          default:
            break
        }
      })
    }
  }

  scrollImages = (side) => {
    const scrollContainer = document.querySelector('.indiana-scroll-container')

    // LEFT BUTTON
    if (side == 'left') {
      if (this.state.imagePosition == 'center') {
        scrollContainer.scrollTo({ left: 0, behavior: 'smooth' })
        this.setState({
          imagePosition: 'left',
        })
      }
      if (this.state.imagePosition == 'left') {
        return
      }
      if (this.state.imagePosition == 'right') {
        scrollContainer.scrollTo({
          left: 0 + (!isMobile ? window.innerWidth / 5 : window.innerWidth * 1),
          behavior: 'smooth',
        })
        this.setState({
          imagePosition: 'center',
        })
      }
    }

    // RIGHT BUTTON
    else {
      if (this.state.imagePosition == 'center') {
        scrollContainer.scrollTo({
          left: !isMobile
            ? (0 + window.innerWidth / 5) * 2
            : window.innerWidth * 1 * 2,
          behavior: 'smooth',
        })
        this.setState({
          imagePosition: 'right',
        })
      }
      if (this.state.imagePosition == 'left') {
        scrollContainer.scrollTo({
          left: 0 + (!isMobile ? window.innerWidth / 5 : window.innerWidth * 1),
          behavior: 'smooth',
        })
        this.setState({
          imagePosition: 'center',
        })
      }
      if (this.state.imagePosition == 'right') {
        return
      }
    }
  }

  onOpenMenuClick = () => {
    this.setState({
      openMenu: !this.state.openMenu,
    })
  }

  closeMenu = () => {
    this.setState({
      openMenu: false,
    })
  }

  changeLocation = (location) => {
    this.props.history.push(location)
  }

  onSubpageChange = (page) => {
    this.setState({
      actualPage: page,
    })
  }

  goBack = () => {
    this.props.history.goBack()
  }

  isThisTodaysEntry = (entryDate) => {
    const date = new Date()
    const formattedTodaysDate = moment(date).format('YYYY-MM-DD')
    let isItToday = false
    if (entryDate && entryDate.creation_datetime == formattedTodaysDate) {
      isItToday = true
    }
    return isItToday
  }

  changeDefaultBackground = (side) => {
    switch (side) {
      case 'front':
        this.setState({
          showFrontBackground: false,
        })
        break
      case 'side':
        this.setState({
          showSideBackground: false,
        })
        break
      case 'back':
        this.setState({
          showBackBackground: false,
        })
        break
    }
  }
  switchAgreementButtons = () => {
    this.setState({
      isAgreementButtonsOn: !this.state.isAgreementButtonsOn,
    })
  }

  onImageSave = (e, side) => {
    this.switchAgreementButtons()

    this.saveTempImages(e.target.files[0], side)
  }

  onEditImageSave = (e, side) => {
    this.switchAgreementButtons()

    this.saveEditTempImages(e.target.files[0], side)
  }

  getImageId = (side, currentFeed) => {
    let letter
    let id
    switch (side) {
      case 'front':
        letter = 'F'
        break
      case 'side':
        letter = 'S'
        break
      case 'back':
        letter = 'B'
        break
      default:
        break
    }
    if (currentFeed) {
      currentFeed.photos.forEach((image) => {
        if (image.type == letter) {
          id = image.id
          return
        }
      })
    }
    return id
  }

  saveEditTempImages = (fileImage, side) => {
    const getImagePath = URL.createObjectURL(fileImage)

    switch (side) {
      case 'front':
        this.setState({
          editTempUserFrontPhoto: fileImage,
          editTempUserFrontBackground: getImagePath,
        })
        break
      case 'side':
        this.setState({
          editTempUserSidePhoto: fileImage,
          editTempUserSideBackground: getImagePath,
        })
        break
      case 'back':
        this.setState({
          editTempUserBackPhoto: fileImage,
          editTempUserBackBackground: getImagePath,
        })
        break
      default:
        return
    }
  }

  enableCompareButton = async () => {
    let userFeeds = this.state.allUserFeeds
    let currentFeed = this.state.currentFeed
    const earlierFeed = userFeeds.reduce((r, o) => (o.date < r.date ? o : r))

    if (earlierFeed && currentFeed) {
      if (
        userFeeds.length >= 2 &&
        earlierFeed.creation_datetime < currentFeed.creation_datetime &&
        earlierFeed.photos.length == 3 &&
        currentFeed.photos.length == 3
      ) {
        this.setState({
          showCompareButton: true,
          earliestFeedId: earlierFeed.id,
          currentFeedId: currentFeed.id,
        })
      }
    }
  }

  saveTempImages = (fileImage, side) => {
    const getImagePath = URL.createObjectURL(fileImage)

    switch (side) {
      case 'front':
        this.setState({
          tempUserFrontPhoto: fileImage,
          tempUserFrontBackground: getImagePath,
        })
        break
      case 'side':
        this.setState({
          tempUserSidePhoto: fileImage,
          tempUserSideBackground: getImagePath,
        })
        break
      case 'back':
        this.setState({
          tempUserBackPhoto: fileImage,
          tempUserBackBackground: getImagePath,
        })
        break
      default:
        return
    }
  }

  resetBackground = (side) => {
    switch (side) {
      case 'front':
        this.setState({
          userFrontPhoto: [],
        })
        break
      case 'side':
        this.setState({
          userSidePhoto: [],
        })
        break
      case 'back':
        this.setState({
          userBackPhoto: [],
        })
        break
      default:
        return
    }
  }
  checkIsToday = (entry) => {
    const splittedDate = entry.split('-')
    const date = new Date()
    const formattedDate = moment(date).format('YYYY-MM-DD')

    return entry.creation_datetime == formattedDate
  }

  // TODO: do this when backend is ready
  removeEntry = () => {}

  enterRemoveImagesMode = () => {
    if (
      this.state.userFrontPhoto.length == 0 &&
      this.state.userBackPhoto.length == 0 &&
      this.state.userSidePhoto.length == 0
    ) {
      return
    }
    this.setState({
      isPhotoReadyForRemove: true,
    })
  }

  exitRemoveImagesMode = () => {
    this.setState({
      isPhotoReadyForRemove: false,
    })
  }

  enterEditEntry = () => {
    this.setState({
      isEditEntry: true,
    })
  }

  removeImage = (e) => {
    this.resetBackground(e.target.dataset.tag)
    setTimeout(() => {
      if (
        this.state.userFrontPhoto.length == 0 &&
        this.state.userBackPhoto.length == 0 &&
        this.state.userSidePhoto.length == 0
      ) {
        this.setState({
          isPhotoReadyForRemove: false,
        })
      }
    }, 0)
  }

  validateFileType = (file) => {
    if (
      file.type != 'image/jpeg' &&
      file.type != 'image/png' &&
      file.type !== 'image/webp'
    ) {
      alert('Proszę wybrać poprawny format zdjęcia')
      return false
    }
    return true
  }

  validateFileSize = (file) => {
    if (file.size > 5000000) {
      alert('Zdjęcie musi być mniejsze niż 5 mb')
      return false
    }
    return true
  }

  returnCorrectSideName = (side) => {
    switch (side) {
      case 'side':
        return 'S'
      case 'front':
        return 'F'
      case 'back':
        return 'B'
      default:
        return
    }
  }

  onChangeHandler = (e, side) => {
    if (
      !this.validateFileType(e.target.files[0]) ||
      !this.validateFileSize(e.target.files[0])
    ) {
      return
    }

    compressImages(e.target.files[0])
    this.setState({
      testFile: e.target.files[0],
    })
    generatePhotoAwsUrl(
      this.returnCorrectSideName(side),
      '2020-07-29',
      e.target.files[0]
    )
  }

  isThereTempImage = (side) => {
    let isTempImageExist = false
    switch (side) {
      case 'front':
        this.state.tempUserFrontBackground
          ? (isTempImageExist = true)
          : (isTempImageExist = false)
        break
      case 'side':
        this.state.tempUserSideBackground
          ? (isTempImageExist = true)
          : (isTempImageExist = false)
        break
      case 'back':
        this.state.tempUserBackBackground
          ? (isTempImageExist = true)
          : (isTempImageExist = false)
        break
      default:
        isTempImageExist = true
        break
    }
    return isTempImageExist
  }

  saveOriginalImages = (side, isEditMode, photoId) => {
    let imageId = this.getImageId(side, this.state.currentFeed)

    if (this.state.currentFeed.photos.length < 3) {
      switch (side) {
        case 'front':
          this.setState({
            userFrontPhoto: this.state.tempUserFrontPhoto,
            userFrontBackground: this.state.tempUserFrontBackground,
          })

          generatePhotoAwsUrl('F', this.state.tempUserFrontPhoto)
          break
        case 'side':
          this.setState({
            userSidePhoto: this.state.tempUserSidePhoto,
            userSideBackground: this.state.tempUserSideBackground,
          })
          generatePhotoAwsUrl('S', this.state.tempUserSidePhoto)

          break
        case 'back':
          this.setState({
            userBackPhoto: this.state.tempUserBackPhoto,
            userBackBackground: this.state.tempUserBackBackground,
          })
          generatePhotoAwsUrl('B', this.state.tempUserBackPhoto)

          break
        default:
          return
      }
    } else {
      switch (side) {
        case 'front':
          this.setState({
            editUserFrontPhoto: this.state.editTempUserFrontPhoto,
            editUserFrontBackground: this.state.editTempUserFrontBackground,
          })

          editImage('F', this.state.tempUserFrontPhoto, imageId)
          notify.show('Poprawnie zedytowano wpis', 'success', 2000)
          setTimeout(() => {
            this.props.history.go(0)
          }, 2000)
          break
        case 'side':
          this.setState({
            editUserSidePhoto: this.state.editTempUserSidePhoto,
            editUserSideBackground: this.state.editTempUserSideBackground,
          })
          editImage('S', this.state.tempUserSidePhoto, imageId)
          notify.show('Poprawnie zedytowano wpis', 'success', 2000)
          setTimeout(() => {
            this.props.history.go(0)
          }, 2000)

          break
        case 'back':
          this.setState({
            editUserBackPhoto: this.state.editTempUserBackPhoto,
            editUserBackBackground: this.state.editTempUserBackBackground,
          })
          editImage('B', this.state.tempUserBackPhoto, imageId)
          notify.show('Poprawnie zedytowano wpis', 'success', 2000)
          setTimeout(() => {
            this.props.history.go(0)
          }, 2000)
          break
        default:
          return
      }
    }

    if (isEditMode) {
      this.setState({
        isEditImageModalOpen: false,
        isEditEntry: false,
      })
    }

    this.switchAgreementButtons()
    this.setState({
      activeStep: this.state.activeStep + 1,
    })
  }

  editImage = (side) => {
    this.setState({
      currentEditingSide: side,
    })
    this.openEditImagesModal()
  }

  resetImage = (side) => {
    switch (side) {
      case 'front':
        this.setState({
          tempUserFrontPhoto: null,
          tempUserFrontBackground: null,
        })
        break
      case 'side':
        this.setState({
          tempUserSidePhoto: null,
          tempUserSideBackground: null,
        })
        break
      case 'back':
        this.setState({
          tempUserBackPhoto: null,
          tempUserBackBackground: null,
        })
        break
      default:
        return
    }
    this.switchAgreementButtons()
  }

  openEditImagesModal = () => {
    this.setState({
      isEditImageModalOpen: true,
    })
  }
  closeEditImagesModal = () => {
    this.setState({
      isEditImageModalOpen: false,
    })
  }

  onRemoveEntry = () => {
    deleteFeed(this.state.currentFeed.id)
    setTimeout(() => {
      this.props.history.push('/postepy')
    }, 1500)
  }

  openRemoveEntryModal = (entry) => {
    this.setState({
      isRemoveEntryModalOpen: true,
    })
  }
  closeRemoveEntryModal = () => {
    this.setState({
      isRemoveEntryModalOpen: false,
    })
  }

  openEditDimensionsModal = () => {
    this.setState({
      isEditDimensionsModalOpen: true,
    })
  }
  closeEditDimensionsModal = () => {
    this.setState({
      isEditDimensionsModalOpen: false,
    })
  }

  saveEditDimensions = () => {
    if (this.state.edit_belly_circumference == null) {
      notify.show(`Proszę wypełnić dane o obwodzie brzucha.`, 'error', 2000)
      return
    }
    if (this.state.edit_hip_circumference == null) {
      notify.show(`Proszę wypełnić dane o obwodzie bioder.`, 'error', 2000)
      return
    }
    if (this.state.edit_thigh_circumference == null) {
      notify.show(`Proszę wypełnić dane o obwodzie uda.`, 'error', 2000)
      return
    }

    editUserFeedDimensions(
      this.state.edit_belly_circumference,
      this.state.edit_hip_circumference,
      this.state.edit_thigh_circumference,
      this.state.currentFeed.id
    )
    this.closeEditDimensionsModal()

    setTimeout(() => {
      this.props.history.push('/postepy')
    }, 2000)
  }

  storeEdittedDimension = (type, e) => {
    switch (type) {
      case 'belly':
        this.setState({
          edit_belly_circumference: e.target.value,
        })
        break
      case 'hip':
        this.setState({
          edit_hip_circumference: e.target.value,
        })
        break
      case 'thigh':
        this.setState({
          edit_thigh_circumference: e.target.value,
        })
        break
      default:
        break
    }
  }

  render() {
    return (
      <EntryScreen
        onSubpageChange={this.onSubpageChange}
        changeLocation={this.changeLocation}
        closeMenu={this.closeMenu}
        onOpenMenuClick={this.onOpenMenuClick}
        openMenu={this.state.openMenu}
        isPlayerActive={this.state.isPlayerActive}
        // entry={this.props.location.state.userEntry}
        goBack={this.goBack}
        history={this.props.history}
        changeDefaultBackground={this.changeDefaultBackground}
        onImageSave={this.onImageSave}
        userFrontPhoto={this.state.userFrontPhoto}
        resetBackground={this.resetBackground}
        user={this.state.user}
        userBackPhoto={this.state.userBackPhoto}
        userSidePhoto={this.state.userSidePhoto}
        scrollImages={this.scrollImages}
        stateImagePosition={this.state.imagePosition}
        checkIsToday={this.checkIsToday}
        onNotCurrentDayAddImageError={this.onNotCurrentDayAddImageError}
        isPhotoReadyForRemove={this.state.isPhotoReadyForRemove}
        enterRemoveImagesMode={this.enterRemoveImagesMode}
        exitRemoveImagesMode={this.exitRemoveImagesMode}
        removeImage={this.removeImage}
        onChangeHandler={this.onChangeHandler}
        testFile={this.state.testFile}
        currentFeed={this.state.currentFeed}
        userBackBackground={this.state.tempUserBackBackground}
        userFrontBackground={this.state.tempUserFrontBackground}
        userSideBackground={this.state.tempUserSideBackground}
        isThisTodaysEntry={this.isThisTodaysEntry}
        isAgreementButtonsOn={this.state.isAgreementButtonsOn}
        saveOriginalImages={this.saveOriginalImages}
        resetImage={this.resetImage}
        userBackBackground={this.state.userBackBackground}
        userFrontBackground={this.state.userFrontBackground}
        userSideBackground={this.state.userSideBackground}
        // isLoading={this.state.isLoading}
        enterEditEntry={this.enterEditEntry}
        isEditEntry={this.state.isEditEntry}
        editImage={this.editImage}
        openEditImagesModal={this.openEditImagesModal}
        closeEditImagesModal={this.closeEditImagesModal}
        isEditImageModalOpen={this.state.isEditImageModalOpen}
        currentEditingSide={this.state.currentEditingSide}
        saveEditTempImages={this.saveEditTempImages}
        onEditImageSave={this.onEditImageSave}
        editTempUserFrontPhoto={this.state.editTempUserFrontBackground}
        editTempUserBackPhoto={this.state.editTempUserBackBackground}
        editTempUserSidePhoto={this.state.editTempUserSideBackground}
        getImageId={this.getImageId}
        photos={this.state.currentFeed}
        openRemoveEntryModal={this.openRemoveEntryModal}
        closeRemoveEntryModal={this.closeRemoveEntryModal}
        isRemoveEntryModalOpen={this.state.isRemoveEntryModalOpen}
        onRemoveEntry={this.onRemoveEntry}
        tempUserFrontBackground={this.state.tempUserFrontBackground}
        tempUserSideBackground={this.state.tempUserSideBackground}
        tempUserBackBackground={this.state.tempUserBackBackground}
        isThereTempImage={this.isThereTempImage}
        showCompareButton={this.state.showCompareButton}
        earliestFeedId={
          this.state.earliestFeedId ? this.state.earliestFeedId : null
        }
        currentFeedId={
          this.state.currentFeedId ? this.state.currentFeedId : null
        }
        isEditDimensionsModalOpen={this.state.isEditDimensionsModalOpen}
        openEditDimensionsModal={this.openEditDimensionsModal}
        closeEditDimensionsModal={this.closeEditDimensionsModal}
        saveEditDimensions={this.saveEditDimensions}
        storeEdittedDimension={this.storeEdittedDimension}
        isDemoAccount={this.state.isDemoAccount}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    entryActions: bindActionCreators(entryActions, dispatch),
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(EntryScreenContainer)
